// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBfEC5aCk49pFI7SGfIomR1IJeBtfC58Hw",
  authDomain: "slatecodex.firebaseapp.com",
  projectId: "slatecodex",
  storageBucket: "slatecodex.firebasestorage.app",
  messagingSenderId: "413765384770",
  appId: "1:413765384770:web:e25e70d55b5825d6020bdb",
  measurementId: "G-S0DJBZKS4S"
};

// Initialize the Firebase application with the provided configuration.
const app = initializeApp(firebaseConfig);

// Initialize Firestore, a NoSQL cloud database, so that you can store and retrieve data.
const db = getFirestore(app);

// Export the services so they can be used throughout your Vue project.
export { db };